 document.addEventListener('DOMContentLoaded', () =>{
    /* Rise */
    document.querySelectorAll(".cmn-ani-rise").forEach((el) =>{
        const text = el.textContent;
        const outerClassList = Array.from(el.classList);      
        const scaleSpan = document.createElement("span");
        scaleSpan.className = "cmn-ani-rise-scale";
        scaleSpan.textContent = text;
        const wordSpan = document.createElement("span");
        wordSpan.className = "cmn-ani-rise-word";
        wordSpan.textContent = text;
        el.textContent = "";
        el.className = outerClassList.join(" ");
        el.appendChild(scaleSpan);
        el.appendChild(wordSpan);
    });
    /* Marker */
    document.querySelectorAll(".cmn-ani-mrk").forEach((el) =>{
        const text = el.textContent;
        const outerClassList = Array.from(el.classList);
        const innerClassList = outerClassList.filter(cls =>cls !== "cmn-ani-obj");
        const innerWordClassList = [...outerClassList.filter(cls =>cls !== "cmn-ani-mrk"), "cmn-ani-mrk-word"];
        const scaleSpan = document.createElement("span");
        scaleSpan.className = "cmn-ani-mrk-scale";
        scaleSpan.textContent = text;
        const wordSpan = document.createElement("span");
        wordSpan.className = innerWordClassList.join(" ");
        wordSpan.textContent = text;
        el.textContent = "";
        el.className = outerClassList.join(" ");
        el.appendChild(scaleSpan);
        el.appendChild(wordSpan);
    });
    /* Animation */
    const aniObjects = document.getElementsByClassName("cmn-ani-obj");
    const aniObserver = new IntersectionObserver(
        (entries, observer) =>{
            entries.forEach(entry =>{
                if (entry.isIntersecting) {
                    entry.target.classList.add("view");        
                }
            });
        },
        { threshold: 0.2 }
    );
    for (let j = 0, len = aniObjects.length; j < len; j++) {
        aniObserver.observe(aniObjects[j]);
    }
});